<template class="full-height">
  <div class="electronicScrollComponents-container">
    <div class="marqee">
      <ul>
        <li>
          {{ content }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ElectronicScrollComponents',
  props: {
    content: {
      type: String,
      default: null,
    },
  },
  components: {},
  data() {
    return {}
  },
  async created() {},
  methods: {},
}
</script>

<style lang="scss">
.marqee {
  top: 2px;
  z-index: 9999;
  height: 3em;
  margin: 0 auto;
  overflow: hidden;
  position: absolute;
  color: yellow;
  background: #dc3545;
  width: 67%;
  margin-left: 17%;
  border-radius: 30px;
}

.marqee > ul {
  padding-left: 0;
  display: flex;
  list-style-type: none;
  animation: marqee 50s linear infinite;
  position: absolute;
}

.marqee > ul > li {
  white-space: nowrap;
  margin-right: 2em;
  font-weight: bold;
  color: yellow;
}

@keyframes marqee {
  0% {
    left: 100%;
    transform: translateX(0%);
  }

  100% {
    left: 0;
    transform: translateX(-100%);
  }
}
</style>
